import { useState, useEffect } from 'react';
import { shouldShowMaintenance } from '../utils/maintenance';

/**
 * Hook to manage user role and maintenance mode bypass
 * This hook can be extended to integrate with your authentication system
 */
export const useUserRole = () => {
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // This is where you would typically:
    // 1. Check localStorage/sessionStorage for user data
    // 2. Make API call to get current user role
    // 3. Use your authentication context (Auth0, Firebase, etc.)
    
    const initializeUserRole = () => {
      try {
        // Example: Get user data from localStorage
        const userData = localStorage.getItem('userData');
        if (userData) {
          const parsedUser = JSON.parse(userData);
          setUserRole(parsedUser.role || parsedUser.userType);
        }
      } catch (error) {
        console.warn('Error reading user role:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeUserRole();
  }, []);

  /**
   * Check if current user can bypass maintenance mode
   */
  const canBypassMaintenance = () => {
    return !shouldShowMaintenance(userRole);
  };

  /**
   * Update user role (call this after login/role change)
   */
  const updateUserRole = (role) => {
    setUserRole(role);
  };

  /**
   * Clear user role (call this after logout)
   */
  const clearUserRole = () => {
    setUserRole(null);
  };

  return {
    userRole,
    isLoading,
    canBypassMaintenance,
    updateUserRole,
    clearUserRole
  };
};

export default useUserRole;
